export async function load (modules = []) {
  const g = IS_BROWSER ? window : global
  const required = ['svelte', 'svelte/internal', 'svelte/internal/disclose-version']

  // Remove duplicates and filter out modules that already exist globally
  modules = [...new Set([...required, ...modules])].filter(mod => !g[mod])

  return Promise.all(modules.map(mod => new Promise(resolve => {
    let p = null

    switch (mod) {
      case 'svelte': p = import('svelte'); break
      case 'svelte/animate': p = import('svelte/animate'); break
      case 'svelte/easing': p = import('svelte/easing'); break
      case 'svelte/internal': p = import('svelte/internal'); break
      case 'svelte/internal/disclose-version': p = import('svelte/internal/disclose-version'); break
      case 'svelte/motion': p = import('svelte/motion'); break
      case 'svelte/store': p = import('svelte/store'); break
      case 'svelte/transition': p = import('svelte/transition'); break
    }

    if (!p) {
      return resolve()
    }

    p.then(m => {
      g[mod] = m

      resolve()
    })
  })))
}
